import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const transform = ({ nameBg, nameEn, studyForms }) => ({
  nameBg,
  nameEn,
  studyForms: (studyForms ?? []).map(
    ({ studyTypeId, instructionLanguageId, annualFee }) => ({
      studyTypeId,
      instructionLanguageId,
      annualFee: annualFee ?? null,
    }),
  ),
});

const CreateDoctoralPrograms = () => {
  return (
    <Create
      title="Създаване на докторантска програма"
      actions={<BackButtonToolbar />}
      transform={transform}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateDoctoralPrograms;
